<app-layout>
  <app-voltar route="listagem/servicos" />
  <div class="headerForm">
    <div class="title">
      <app-titulo>{{ title }}</app-titulo>
    </div>
    <div class="espacamento"></div>
  </div>

  <div class="forms">
    <form
      [formGroup]="form"
      [ngStyle]="!isViewing ? { 'margin-bottom': '48px' } : {}">
      <div class="formList">
        <app-input
          type="text"
          label="Placa do Cavalo"
          placeholder="Digite"
          name="TX_PLCA_CAVA"
          formControlName="TX_PLCA_CAVA"
          mask="AAA-0000||AAA-0A00"
          [requiredInput]="!isViewing"
          (ngModelChange)="getEntrada()"
          [disabled]="true"></app-input>
        <app-input
          type="disabled"
          label="Data/Hora da Entrada no Gate"
          name="DT_GATE_ENTR"
          formControlName="DT_GATE_ENTR"
          [disabled]="true"></app-input>
        <app-input
          type="disabled"
          label="Data/Hora da Fila"
          name="DT_FILA"
          formControlName="DT_FILA"
          [disabled]="true"></app-input>
        <app-input
          type="select"
          label="Serviço"
          name="FK_SRVC"
          formControlName="FK_SRVC"
          [requiredInput]="!isViewing"
          [selectData]="servicoOptions"
          (ngModelChange)="escolherServico($event)"
          [disabled]="true">
        </app-input>
        <app-input
          type="select"
          label="Tipo da Carreta"
          name="FK_TIPO_CRRT"
          formControlName="FK_TIPO_CRRT"
          [requiredInput]="!isViewing"
          [selectData]="tipoCarretaOptions"
          (ngModelChange)="escolherTipoCarreta($event)"
          [disabled]="true"></app-input>
        <app-input
          type="select"
          label="Quantidade de Eixos"
          name="QT_TOTL_EIXO"
          formControlName="QT_TOTL_EIXO"
          [requiredInput]="!isViewing"
          [selectData]="tipoEixosOptions"
          (ngModelChange)="escolherQuantidadeEixo($event)"
          [disabled]="true"></app-input>
        <app-input
          type="select"
          label="Quantidade de Compartimentos"
          name="QT_CPTM"
          formControlName="QT_CPTM"
          [selectData]="qtdCompartimentosOptions"
          (ngModelChange)="escolherCompartimento($event)"
          [disabled]="true"></app-input>
        <app-input
          type="select"
          label="Tipo Carga"
          name="FK_CRGA"
          formControlName="FK_CRGA"
          [requiredInput]="!isViewing"
          [selectData]="tipoCargaOptions"
          (ngModelChange)="escolherCarga($event)"
          [disabled]="true"></app-input>
        <app-input
          type="text"
          label="Observação"
          placeholder="Digite"
          name="TX_OBSV_SRVC_ENTR"
          formControlName="TX_OBSV_SRVC_ENTR"></app-input>
      </div>
    </form>
  </div>

  <div class="tabela">
    <app-tabela-form
      *ngIf="!isLoading && this.tableData.length"
      [data]="tableData"
      [columns]="tableColumns"></app-tabela-form>
  </div>
  <div class="tabela-mobile">
    <app-card
      *ngIf="!isLoading"
      [data]="tableData"
      [rows]="tableColumns"
      [expand]="true" />
  </div>
</app-layout>

<app-loader [isLoading]="isLoading"></app-loader>
